import { lazy, LazyExoticComponent, FC } from "react";
import FullLayout from "layouts/full";
import CommonLayout from "layouts/common";
import FullLayoutWithFilters from "layouts/fullWithFilters";
import retry from "routes/retry";

export type AppRoute = {
  path: string;
  component: LazyExoticComponent<FC<any>>;
  layout: FC<any> | null;
  title?: string;
  exact?: boolean;
  isPrivate?: boolean;
};

const routes: Array<AppRoute> = [
  {
    path: "/invalid-token",
    component: lazy(() => retry(() => import("./pages/invalid-token"))),
    layout: CommonLayout,
    title: "Invalid Token",
    exact: true,
  },
  {
    path: "/auth/:token",
    component: lazy(() => retry(() => import("./pages/auth"))),
    layout: null,
    title: "Authorization",
    exact: true,
  },
  {
    path: "/app/overview",
    component: lazy(() => retry(() => import("./pages/dashboard"))),
    layout: FullLayout,
    title: "Overview",
    isPrivate: true,
  },
  {
    path: "/app/job-list/:type?/:id?/:customerId?",
    component: lazy(() => retry(() => import('./pages/job-list'))),
    layout: FullLayoutWithFilters,
    title: 'Job List',
    isPrivate: false // to avoid logout
  },
  {
    path: "/app/comment-report/:type/:day",
    component: lazy(() => retry(() => import('./pages/comment-report'))),
    layout: FullLayoutWithFilters,
    title: 'Rep Comment Report',
    isPrivate: true
  },
  {
    path: "/app/assignment-report",
    component: lazy(() => retry(() => import('./pages/assignment-report'))),
    layout: FullLayoutWithFilters,
    title: 'Assignment Report',
    isPrivate: true
  },
  {
    path: "/app/associates/:type/:id",
    component: lazy(() => retry(() => import('./pages/associates'))),
    layout: FullLayoutWithFilters,
    title: 'Associates',
    isPrivate: true
  },
  {
    path: "/app/my-tasks/:type",
    component: lazy(() => retry(() => import('./pages/my-tasks'))),
    layout: FullLayoutWithFilters,
    title: 'My Tasks',
    isPrivate: true
  },
  {
    path: "/app/worked-in-last-30-days",
    component: lazy(() => retry(() => import('./pages/worked-in-last-30-days'))),
    layout: FullLayoutWithFilters,
    title: 'Worked in last 30 days',
    isPrivate: true
  },
  {
    path: "/app/worker-report/:roleId/:teamId?",
    component: lazy(() => retry(() => import("./pages/worker-report"))),
    layout: FullLayoutWithFilters,
    title: "Worker Report"
  },
  {
    path: "/terms-and-conditions",
    component: lazy(() => retry(() => import("./pages/terms-of-use/termsAndConditions"))),
    layout: FullLayout,
    title: "Terms and Conditions",
  },
  {
    path: "/privacy",
    component: lazy(() => retry(() => import("./pages/terms-of-use/privacy"))),
    layout: FullLayout,
    title: "Privacy",
  },
];

export default routes;
